import { createRoot } from "react-dom/client";
import { PreferencesPage } from "@workboard/ui-preferences";
import { useTranslation } from "react-i18next";

// Resolved server-side by AgentStartPageFacade::pickerStateForUser and injected by
// the userPreferences view. visible=false hides the Agents option; visible with an
// empty options list greys it out.
type AgentStartPageState = {
  visible: boolean;
  options: { value: string; label: string }[];
};

const HIDDEN: AgentStartPageState = { visible: false, options: [] };

const UserPreferencesPage = ({ agentStartPage }: { agentStartPage: AgentStartPageState }) => {
  const { t } = useTranslation();
  const { enableModules, isCncGenAiCalibrateEnabled } = wbConfig || {};
  const featureFlags = {
    isExecuteModuleEnabled: Boolean(enableModules?.execute ?? false),
    isGoalModuleEnabled: Boolean(enableModules?.goal ?? false),
    isCncGenAiCalibrateEnabled: Boolean(isCncGenAiCalibrateEnabled),
    isAgentsStartPageEnabled: agentStartPage.visible,
  };
  return (
    <PreferencesPage
      featureFlags={featureFlags}
      agentOptions={agentStartPage.options}
      onTranslate={(key) => t(key)}
      onToast={(event) => {
        if (event.type && event.message) {
          toastr?.[event.type]?.(event.message);
        }
      }}
    />
  );
}

// agentStartPage defaults to hidden so a cached template calling this with one
// argument still renders the page as it does today.
const initPreferencesPage = (mountId: string, agentStartPage: AgentStartPageState = HIDDEN) => {
  const root = document.getElementById(mountId);
  if (root) {
    createRoot(root).render(<UserPreferencesPage agentStartPage={agentStartPage} />);
  }
}

window.initPreferencesPage = initPreferencesPage;
